//
// Error message mixin
// ----------

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var util = require('utils');
    var i18n = require('i18n');

    module.exports = {

        /**
         * Check that the error response contains `userErrors`
         * @param error
         * @return {boolean}
         * @private
         */
        _hasUserErrors: function(error) {
            var userErrors = util.fromPath(error, 'data.userErrors');
            return Boolean(userErrors && userErrors.length);
        },

        /**
         * Check that the error response contains `actions`
         * @param error
         * @return {boolean}
         * @private
         */
        _hasActions: function(error) {
            return !_.isEmpty(util.fromPath(error, 'data.actions'));
        },

        /**
         * Returns message based on `errorCode` and `errorMessage`
         * @param error
         * @return {Object}
         * @private
         */
        _createMessageByDefault: function(error) {
            var data = error && error.data || {};
            var defaultMessage = data.playerMessage || data.errorMessage || data.errorText || data.message;
            return this._createMessage(data.errorCode, defaultMessage);
        },

        /**
         * Returns message based on properties `templateId` and `message` of first user error
         * @param error
         * @return {Object}
         * @private
         */
        _createMessageByUserErrors: function(error) {
            var userErrors = util.fromPath(error, 'data.userErrors');
            return this._createMessage(userErrors[0].templateId, userErrors[0].message);
        },

        _createMessageByActions: function(error) {
            var data = error.data;
            var defaultMessage = data.playerMessage || data.errorMessage || data.errorText;

            if (Array.isArray(data.actions)) {
                return this._createMessageFromActionsArray(data, defaultMessage);
            }

            return this._createMessageFromActionsObject(data, defaultMessage);
        },

        _createMessageFromActionsArray: function(data, defaultMessage) {
            var actions = data.actions;
            var messages = actions
                .filter(function(action) {
                    return action.showMessageNotificationInfo && action.showMessageNotificationInfo.message;
                })
                .map(function(action) {
                    return {
                        content: action.showMessageNotificationInfo.message,
                        className: 'error'
                    };
                });

            return messages.length
                ? messages
                : this._createMessage(data.errorCode, defaultMessage);
        },

        /**
         * Returns message based on response from PAS
         * @private
         * @param data
         * @param defaultMessage
         * @return {Object}
         */
        _createMessageFromActionsObject: function(data, defaultMessage) {
            var actionMessages = data.actions.PlayerActionShowMessage || [];
            var message = actionMessages[0] ? actionMessages[0].message : defaultMessage;
            return this._createMessage(data.errorCode, message);
        },

        /**
         * Error message creator
         * @param key
         * @param defaultValue
         * @return {Object}
         * @private
         */
        _createMessage: function(key, defaultValue) {
            return {
                content: i18n.tExt('playtech.mobile.registration.error.' + key, defaultValue),
                className: 'error'
            };
        },

        /**
         * Handles error response and returns necessary message
         * @param error
         * @return {Object}
         */
        getRegistrationErrorMessage: function(error) {
            if (this._hasUserErrors(error)) {
                return this._createMessageByUserErrors(error);
            }

            if (this._hasActions(error)) {
                return this._createMessageByActions(error);
            }

            return this._createMessageByDefault(error);
        }

    };
});
